module.exports = __webpack_public_path__ + "static/media/21.0dd9c39c.mp3";